import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const $productLinks = document.querySelectorAll<HTMLElement>('.nav-link-product');
const $productDropdown = document.querySelector<HTMLElement>('#nav-product-dropdown');

$productLinks.forEach($product => {
    let startHideTimeout: number;
    let finishHideTimeout: number;

    const showDropdown = () => {
        clearTimeout(startHideTimeout);
        clearTimeout(finishHideTimeout);

        if (!$productDropdown) {
            return;
        }

        $productDropdown.classList.remove('d-none');

        setTimeout(() => {
            $productDropdown.classList.add('show');

            setTimeout(() => {
                const hide = (e: Event) => {
                    if (e instanceof MouseEvent) {
                        if ($productDropdown.contains(e.relatedTarget as Node)) {
                            return;
                        }
                    } else if (e instanceof TouchEvent) {
                        if (e.touches[0].target === $productDropdown) {
                            return;
                        }
                    }

                    clearTimeout(startHideTimeout);
                    clearTimeout(finishHideTimeout);

                    startHideTimeout = setTimeout(() => {
                        $productDropdown.classList.remove('show');

                        finishHideTimeout = setTimeout(() => {
                            $productDropdown.classList.add('d-none');
                        }, 100);
                    }, 300);

                    $productDropdown.removeEventListener('mouseleave', hide, true);
                    document.body.removeEventListener('click ', hide, true);
                    document.body.removeEventListener('touchstart', hide, true);
                };

                $productDropdown.addEventListener('mouseleave', hide, true);
                document.body.addEventListener('click', hide, true);
                document.body.addEventListener('touchstart', hide, true);
            });
        });
        $productDropdown.addEventListener('mouseenter', showDropdown);
    };

    $product.addEventListener('mouseenter', showDropdown);
    $product.addEventListener('click', e => {
        e.preventDefault();

        showDropdown();
    });
});

const $header = document.querySelector<HTMLElement>('header');

setInterval(() => {
    if (!$header || !$productDropdown) {
        return;
    }

    $productDropdown.style.setProperty('--header-height', `${$header.offsetHeight}px`);
}, 100);

const $mobileNavProducts = document.querySelector<HTMLElement>('#mobile-nav-products');
const $mobileNavSwiper = $mobileNavProducts?.querySelector<HTMLElement>('.swiper');

if ($mobileNavSwiper) {
    new Swiper($mobileNavSwiper, {
        modules: [Navigation, Pagination],

        // Optional parameters
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 32,

        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}